enum CycleStatus {
  InActive = 'inactive',
  Active = 'active',
  Completed = 'completed',
  // Not a real cycle status - used only for the "Deleted" tab's URL/routing,
  // never sent as an actual status value when creating/updating a cycle.
  Deleted = 'deleted',
}

export default CycleStatus;